class MainStore {}

export default new MainStore();
